import CarrierBadge from "./CarrierBadge";
import { formatMXN, formatDate } from "@/lib/format";
import UserCurrencyPrice from "@/components/quote/UserCurrencyPrice";
import { carrierDisplayOverride } from "@/lib/carriers";
import { isFeaturedRate, FEATURED_ROW_CLS } from "@/lib/featuredRate";
import { Gauge, FileText, Star, Ban, Check } from "lucide-react";
import PickupBadge from "./quote/PickupBadge";
import SavingsBadge from "./quote/SavingsBadge";
import OriginalCurrencyTooltip from "./quote/OriginalCurrencyTooltip";
import { getAggregatorLabel } from "@/lib/aggregatorLabel";

export default function RateRow({ rate, onSelect, selected, selectLabel, funded = true }) {
  const cheapest = rate._rank === "cheapest";
  const fastest = rate._rank === "fastest";
  const featured = isFeaturedRate(rate);
  return (
    <div className={`surface px-3 py-2 flex items-center gap-3 ${featured ? FEATURED_ROW_CLS : ""} ${selected ? "border-l-2 border-cyan bg-cyan/10 ring-1 ring-cyan" : ""}`}>
      <div className="min-w-0 flex-1 flex items-center gap-2">
        <CarrierBadge carrier={rate.carrier} size="sm" displayName={carrierDisplayOverride(rate.carrier, rate.source)} />
        <div className="min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className="text-[0.6rem] uppercase text-ink-muted border border-ink-border px-1.5 py-0.5">{getAggregatorLabel(rate) || rate.source}</span>
            <PickupBadge pickup={rate.pickup} size="xs" />
            {featured && (
              <span className="flex items-center gap-0.5 text-[0.6rem] uppercase font-bold text-violet-500 dark:text-violet-300 bg-violet-500/15 border border-violet-500/50 px-1.5 py-0.5">
                <Star className="w-2.5 h-2.5 fill-current" /> Destacado
              </span>
            )}
            {cheapest && <span className="text-[0.6rem] uppercase font-bold text-success">Econ</span>}
            {fastest && <span className="text-[0.6rem] uppercase font-bold text-cyan">Rápida</span>}
          </div>
          <div className="text-[0.65rem] text-ink-muted flex items-center gap-2 mt-0.5">
            <span className="flex items-center gap-0.5"><Gauge className="w-3 h-3" />{rate.transit_days}d</span>
            {rate.zone && <span className="font-mono">{rate.zone}</span>}
            {rate.service && <span className="truncate">{rate.service}</span>}
          </div>
        </div>
      </div>
      <div className="text-right shrink-0">
        <OriginalCurrencyTooltip rate={rate}>
          <div className={`font-display font-bold text-lg leading-none ${featured ? "text-violet-500 dark:text-violet-300" : "text-cyan"} cursor-help`}>
            <UserCurrencyPrice mxn={rate.total_cost} size="sm" />
          </div>
        </OriginalCurrencyTooltip>
        <div className="text-[0.6rem] text-ink-muted">{formatDate(rate.eta)}</div>
        <SavingsBadge rate={rate} compact />
      </div>
      {funded ? (
        <button onClick={() => onSelect(rate)}
          className={`shrink-0 flex items-center gap-1 px-3 py-2 font-display font-bold uppercase text-[0.65rem] ${selected ? "bg-cyan text-ink ring-1 ring-cyan" : featured ? "bg-violet-500 hover:bg-violet-600 text-white" : "bg-cyan hover:bg-cyan-hover text-ink"}`}>
          {selected ? <><Check className="w-3 h-3" /> Seleccionada</> : <><FileText className="w-3 h-3" /> {selectLabel || "Elegir"}</>}
        </button>
      ) : (
        <button disabled
          className="shrink-0 flex items-center gap-1 px-3 py-2 font-display font-bold uppercase text-[0.65rem] border border-destructive/40 text-destructive bg-destructive/5 cursor-not-allowed"
          title="El convenio no está disponible">
          <Ban className="w-3 h-3" /> No disponible
        </button>
      )}
    </div>
  );
}